export interface Clinic {
  id: string;
  name: string;
  specialty: string;
  address: string;
  district: string;
  phone: string;
  rating: number;
  distance: string;
  acceptsNewPatients: boolean;
  networkProvider: boolean;
}

export const mockClinics: Clinic[] = [
  {
    id: 'cl1',
    name: "Maternity & Women's Health Centre",
    specialty: 'Obstetrics & Gynecology',
    address: "123 Queen's Road Central, Hong Kong",
    district: 'Central',
    phone: '+852 2123 4567',
    rating: 4.8,
    distance: '1.2 km',
    acceptsNewPatients: true,
    networkProvider: true,
  },
  {
    id: 'cl2',
    name: 'Hong Kong Prenatal Care Clinic',
    specialty: 'Prenatal Care',
    address: '456 Nathan Road, Kowloon',
    district: 'Tsim Sha Tsui',
    phone: '+852 2234 5678',
    rating: 4.6,
    distance: '3.5 km',
    acceptsNewPatients: true,
    networkProvider: true,
  },
  {
    id: 'cl3',
    name: 'Family Health Medical Centre',
    specialty: 'Family Medicine',
    address: '789 Hennessy Road, Causeway Bay',
    district: 'Causeway Bay',
    phone: '+852 2345 6789',
    rating: 4.7,
    distance: '2.8 km',
    acceptsNewPatients: true,
    networkProvider: true,
  },
  {
    id: 'cl4',
    name: 'Peak Wellness Clinic',
    specialty: 'General Practice',
    address: '321 Des Voeux Road, Sheung Wan',
    district: 'Sheung Wan',
    phone: '+852 2456 7890',
    rating: 4.5,
    distance: '1.8 km',
    acceptsNewPatients: false,
    networkProvider: true,
  },
  {
    id: 'cl5',
    name: 'Victoria Maternity Hospital',
    specialty: 'Maternity & Delivery',
    address: '555 Gloucester Road, Wan Chai',
    district: 'Wan Chai',
    phone: '+852 2567 8901',
    rating: 4.9,
    distance: '2.1 km',
    acceptsNewPatients: true,
    networkProvider: true,
  },
];
